/**
 * shadcn class-name utility.
 *
 * Combines `clsx` (conditional joining) with `tailwind-merge` (intelligent
 * deduplication of Tailwind classes, e.g. "bg-red bg-blue" → "bg-blue").
 *
 * Every shadcn component in `components/ui/` uses this. Feature code should
 * also use `cn()` when composing Tailwind classes conditionally.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
